import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import formatNumber from 'helpers/formatNumber';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import {
  ApplicationIcon,
  WorkOrdersIcon,
  AreaIcon,
  CropSeasonIcon,
  OrgIcon
} from '../SvgIcons';
import { Locale, en } from '../../locales';

interface HeaderProps {
  applicationName: string;
  organization: string;
  totalAppliedArea: number;
  cropSeasons: string[];
  operationType: OperationType;
  locale?: Locale;
}

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  type: {
    fontSize: 16,
    fontWeight: 600
  },
  title: {
    fontSize: 14,
    fontFamily: 'Noto Sans',
    marginLeft: 4
  },
  metadataRow: {
    fontSize: 10,
    fontFamily: 'Noto Sans',
    flexWrap: 'wrap'
  },
  metadataItem: {
    paddingRight: 8,
    marginRight: 8,
    borderRight: '1px solid #C2C7D0'
  },
  metadataText: {
    marginLeft: 2,
    height: 14,
    whiteSpace: 'nowrap',
    flexWrap: 'nowrap'
  }
});

const Header: React.FC<HeaderProps> = ({
  applicationName,
  organization,
  cropSeasons,
  totalAppliedArea,
  operationType,
  locale = en
}) => (
  <View style={{ marginBottom: 8 }}>
    <View
      style={[styles.row, { marginBottom: 4, alignItems: 'flex-start' }]}
      wrap={false}
    >
      {operationType === OperationType.APPLICATION ? (
        <ApplicationIcon />
      ) : (
        <WorkOrdersIcon />
      )}
      <Text style={styles.title}>
        <Text style={styles.type}>
          {operationType === OperationType.APPLICATION
            ? `${locale.common.application}:`
            : `${locale.common.work_order}:`}{' '}
        </Text>
        {applicationName}
      </Text>
    </View>
    <View style={[styles.row, styles.metadataRow]} wrap={false}>
      <View style={[styles.row, styles.metadataItem]}>
        <OrgIcon />
        <Text style={styles.metadataText}>{organization}</Text>
      </View>
      <View style={[styles.row, styles.metadataItem]}>
        <CropSeasonIcon />
        <Text style={styles.metadataText}>{cropSeasons.join(', ')}</Text>
      </View>
      <View style={[styles.row]}>
        <AreaIcon />
        <Text style={styles.metadataText}>
          {formatNumber(totalAppliedArea, 'ac')}
        </Text>
      </View>
    </View>
  </View>
);

export default Header;
